window.Page = {

    prevButtons      : document.querySelectorAll('.gallery-button-prev'),
    nextButtons      : document.querySelectorAll('.gallery-button-next'),

    // Let's launch this thing
    liftoff : () => {
        Page.moveGalleryForward()
        Page.moveGalleryBackwards()
    },

    moveGalleryForward : () => {
        Page.nextButtons.forEach(button => {
            button.addEventListener('click' , () => {
                
                // Grab the current active picture inside the gallery
                let slideCurrent = button.parentElement.querySelector('.active')
                let slideNext    = slideCurrent.nextElementSibling

                // If the next element is not an image do nothing
                if (!slideNext.classList.contains('next')) return;

                // We clicked on prev so it means we need to show the other button
                let prevButton = button.parentElement.querySelector('.gallery-button-prev').classList.remove('disabled')

                // Disable the current slide and move it to the left
                slideCurrent.classList.remove('active')
                slideCurrent.classList.add('prev')

                // Bring in view the next slide
                slideNext.classList.remove('next')
                slideNext.classList.add('active')

                // Grab the counter
                let counter = button.parentElement.querySelector('.grid-counter-current')
                let total   = button.parentElement.querySelector('.grid-counter-total')

                    // Adjust the counter number
                    counter.innerHTML = Math.abs(counter.innerHTML) + 1

                if (counter.innerHTML == total.innerHTML)
                        button.classList.add('disabled')


            })
        })
    },

    moveGalleryBackwards : () => {
        Page.prevButtons.forEach(button => {
            button.addEventListener('click' , () => {
                
                // Grab the current active picture inside the gallery
                let slideCurrent = button.parentElement.querySelector('.active')
                let slidePrev    = slideCurrent.previousElementSibling


                // If the next element is not an image do nothing
                if (!slidePrev.classList.contains('prev')) return;

                // We clicked on prev so it means we need to show the other button
                let nextButton = button.parentElement.querySelector('.gallery-button-next').classList.remove('disabled')

                // Disable the current slide and move it to the left
                slideCurrent.classList.remove('active')
                slideCurrent.classList.add('next')

                // Bring in view the next slide
                slidePrev.classList.remove('prev')
                slidePrev.classList.add('active')

                // Grab the counter
                let counter = button.parentElement.querySelector('.grid-counter-current')
                    counter.innerHTML = Math.abs(counter.innerHTML) - 1

                    if (Math.abs(counter.innerHTML) == 1)
                        button.classList.add('disabled')

            })
        })        
    }

};

Page.liftoff()